import './app.css';

import '@babel/polyfill';



/* is production */
const isProd = process.env.NODE_ENV === 'production';

/* WebGL message */
require('./js/viscom/vereschagin/app/WebGLMessage.js');

/* meta */
const meta = require('./js/meta.json');

/* data [UNCOMMENT THE LINE BELOW TO USE TEXTS FROM DATA IN JS] */
// const data = require('./js/data.json');



/* analytics */
/* SEND EVENT: analyticsEvent('Button', 'click', 'Play'); */

const analyticsEvent = require('./js/viscom/viscomjs/analytics/analyticsEvent');

analyticsEvent('Page', 'load', 'Load');

/* track events from html attributes */
const trackingElements = [...document.querySelectorAll('[data-event][data-event-category][data-event-label]')];

if (trackingElements.length > 0) {
    trackingElements.forEach(trackingElem => {
        trackingElem.addEventListener(trackingElem.getAttribute('data-event'), () => {
            analyticsEvent(
                trackingElem.getAttribute('data-event-category'),
                trackingElem.getAttribute('data-event'),
                trackingElem.getAttribute('data-event-label')
            );
        });
    });
}



/* fonts */
const WebFont = require('webfontloader');

WebFont.load({
    custom: {
        families: ['Libre Baskerville:n4,n7'],
        urls: ['./css/fonts.css']
    },
    google: {
        families: ['Open+Sans:400, 700:cyrillic']
    }
});



/* share */
import * as VanillaSharing from 'vanilla-sharing';

const shareButtons = [...document.querySelectorAll('.share__item')];

if (shareButtons.length > 0) {

    const shareOptions = {
        url: meta.url,
        title: meta.title,
        description: meta.description,
        image: meta.image,
        isVkParse: false,
        fbAppId: meta.fbappid
    };

    shareButtons.forEach(button => {
        button.addEventListener('click', () => {
            if (button.dataset.social === 'all' && navigator.share !== undefined) {
                navigator.share({
                    title: shareOptions.title,
                    url: shareOptions.url
                });
            } else {
                VanillaSharing[button.dataset.social](shareOptions);
            }

            analyticsEvent('Share', 'click', 'Social: ' + button.dataset.social);
        });
    });

}



/* service worker */
if ('serviceWorker' in navigator && isProd) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('./sw.js');
    });
}



/* jquery [UNCOMMENT THE LINE BELOW TO USE JQUERY IN JS] */
// window.$ = window.jQuery = require('jquery');
{
    require('./js/viscom/vereschagin/sound/sound');
}

{
    function startProject() {
        const preloader = require('./js/viscom/vereschagin/load/Preloader');
        const PIXIPreload = require('./js/viscom/vereschagin/load/PIXIPreload');
        const manifest = require('./js/viscom/vereschagin/Manifest');

        const startLoadTime = new Date().getTime();
        const delay = isProd ? 7000 : 1;

        PIXIPreload(manifest.manifest, {baseUrl: manifest.baseUrl}, preloader.update).then(() => {
            const t = new Date().getTime();
            const Project = require('./js/viscom/vereschagin/Project');
            preloader.update({
                progress: 100
            });
            setTimeout(() => {
                preloader.destroy();
                setTimeout(() => {
                    Project.init().start();
                    // require('./js/viscom/vereschagin/sound/sound');
                    console.clear();
                }, 800);
            }, Math.max(0, delay - (t - startLoadTime)));

        }, () => {
            // NO IMAGE LOADED
        });
    }

    startProject();
}








// WEBPACK FOOTER //
// ./app.js